import styled, { css } from "styled-components/native";
import { TouchableHighlight, Text } from "react-native";
import { StyledProps, DisabledProps } from "./types";
import { Theme } from "../../../../theming/types";

export const StyledPressable = styled(TouchableHighlight)<
  StyledProps & DisabledProps
>`
  min-height: 42px;
  background-color: ${({ theme }: { theme: Theme }) => theme.colors.white[900]};
  padding: ${({ theme }: { theme: Theme }) => theme.space["space-4"]};
  justify-content: center;
  align-items: left;
  ${({ isHovered, isDisabled, theme }: StyledProps & DisabledProps) =>
    isHovered &&
    css`
      background-color: ${theme.colors.blue_accent["000"]};
      cursor: ${isDisabled ? "default" : "pointer"};
    `}
  ${({ isPressed, theme }: StyledProps) =>
    isPressed &&
    css`
      background-color: ${theme.colors.blue_accent[100]};
    `}
  ${({ isDisabled, theme }: DisabledProps & { theme: Theme }) =>
    isDisabled &&
    css`
      background-color: ${theme.colors.white[500]};
    `};
  ${({ isSelected, theme }: StyledProps) =>
    isSelected &&
    css`
      background-color: ${theme.colors.blue_accent["000"]};
      border-bottom-color: ${theme.colors.blue["000"]};
      border-bottom-width: 1px;
      border-left-color: ${theme.colors.blue_accent[500]};
      border-left-width: 2px;
    `}
`;

export const StyledTextTitle = styled(Text)<StyledProps & DisabledProps>`
  ${({
    theme,
    isSelected,
    isPressed,
    isDisabled
  }: StyledProps & DisabledProps) => css`
    font-family: ${isSelected || isPressed
      ? theme.fonts.medium
      : theme.fonts.regular};
    font-size: ${theme.fontSizes.s};
    color: ${((isSelected || isPressed) && theme.colors.blue_accent[500]) ||
    (isDisabled && theme.colors.grey[600]) ||
    theme.colors.grey[900]};
  `}
`;

export const StyledTextDescription = styled(Text)<StyledProps>`
  ${({ theme, isSelected, isPressed }: StyledProps) => css`
    font-family: ${isSelected || isPressed
      ? theme.fonts.medium
      : theme.fonts.regular};
    font-size: ${theme.fontSizes.xs};
    color: ${theme.colors.grey[700]};
  `}
`;
